<template>
    <div class="lang-switch" :class="{'inverted' : lang === 'de'}">
        <img :src="require(`../assets/img/lang/en.svg`)" alt="lang" title="Switch to english" @click="switchLang($event, 'en')" />
        <img :src="require(`../assets/img/lang/de.svg`)" alt="lang" title="Auf deutsch umstellen" @click="switchLang($event, 'de')" />
    </div>
</template>

<script>

export default {
    name: 'LangSwitch',
    computed: {
        lang() {
            return this.$i18n.locale || 'en';
        }
    },
    methods: {
        switchLang(e, lang) {
            e.preventDefault();

            this.$root.$i18n.locale = lang;

            const path = `/${lang}${this.$route.path.replace(/^\/(en|de)/, '')}`;

            if (this.$route.path !== path) {
                this.$router.replace({
                    path: path
                });
            }
        }
    }
}
</script>
